import { render, staticRenderFns } from "./InspectionViewInspectionCommentAndSign.vue?vue&type=template&id=204c9ca8"
import script from "./InspectionViewInspectionCommentAndSign.vue?vue&type=script&lang=js"
export * from "./InspectionViewInspectionCommentAndSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports